import React, { useMemo, useState } from 'react'
import * as API from '../../api.js'
import Button from '../../ReusableComponents/Button/Button'
import { Popup } from '../../ReusableComponents/reusableFunctions'
import ReportBody from './ReportBody'
import { getSprayPaths } from './ReportMaps'

const SprayQualityReport = ({ flightId, report, telemetry }) => {
    const [downloading, setDownloading] = useState(false)

    const paths = useMemo(() => getSprayPaths(report, telemetry), [report, telemetry])

    const downloadPdf = () => {
        setDownloading(true)
        API.downloadFlightQualityReportPdf(flightId)
            .catch(e => Popup.alert("ERROR", e?.message || 'Failed to download the report, please try again.'))
            .finally(() => setDownloading(false))
    }

    return (
        <div className="sqr-page">
            <div className="sqr-toolbar">
                <div className="sqr-toolbar-title">Spraying Quality Report</div>
                <Button
                    text={downloading ? 'Downloading...' : 'Download PDF'}
                    isDisabled={!report || downloading}
                    onClick={downloadPdf}
                />
            </div>
            {report
                ? <div className="sqr-paper">
                    <div className="sqr-beta-ribbon" title="This report is in beta. Results are for guidance and may change as we improve the analysis.">BETA</div>
                    <ReportBody report={report} paths={paths} />
                </div>
                : <div className="sqr-message">No spraying report available for this flight.</div>}
        </div>
    )
}

export default SprayQualityReport
